/** The room card and the board header count the same things the same way. */
export function itemCountLabel(count: number | undefined): string {
  if (count === undefined) return '';
  if (count === 0) return 'Nothing yet';
  return `${count} ${count === 1 ? 'item' : 'items'}`;
}

/** While a search is filtering the board: how much of the room is left. */
export function matchCountLabel(found: number, total: number): string {
  if (found === 0) return `Nothing of ${total} matches`;
  return `${found} of ${total} ${total === 1 ? 'item' : 'items'} match${found === 1 ? 'es' : ''}`;
}

/**
 * Dropping files on the board and dropping them on the panel fail the same
 * way. Naming the one bad file says which to go and look at; past that, the
 * count is the useful part.
 */
export function couldntReadLabel(failed: readonly string[]): string {
  if (failed.length === 1) return `${failed[0] ?? 'One file'} couldn't be read as an image.`;
  return `${failed.length} files couldn't be read as images. The rest were added.`;
}
